/**
 * Converts JS `Date.getTimezoneOffset()` (minutes BEHIND UTC — Moscow UTC+3 → -180,
 * New York UTC-5 → +300) into signed hours EAST of UTC (Moscow → +3, New York → -5).
 *
 * This is the value stored in `timeZoneOffset`: the picker options and
 * `getTzFromNumber` both use signed hours. The old writer used `abs()` and dropped
 * the sign, which broke western time zones for both date display and the digest.
 */
export const signedTimeZoneOffsetHours = (getTimezoneOffsetMinutes: number): number => {
  const hours = Math.round(-getTimezoneOffsetMinutes / 60);
  return hours === 0 ? 0 : hours; // normalize -0 (Math.round(-0)) to 0
};
